const state = {
  isOpen: true
}

const getters = {}

const actions = {}

const mutations = {
  toggleSidebar (state) {
    state.isOpen = !state.isOpen
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js